import React, { useEffect } from 'react'
import { Truncate } from '../Truncate/Truncate'
import Icon from '../Icon2/Icon'
import Checkbox from '../Checkbox/Checkbox'
import Tooltip from '../Tooltip/Tooltip'

export const VariantGroupsList = ({
  isListDisabled,
  onVariantClickHandler,
  clickableBaseclassname,
  variantListData,
  selectedContentTypeName,
  lastElementRef,
  variantTags,
  setVariantTags,
  multiSelectTag,
  onClickHandler,
  disableNonCreatedVariant
}: any) => {
  const checkForSelectedVariant = (variant_uid: string) => {
    return variantTags.some((vl_el: any) => vl_el.value === variant_uid)
  }

  const onVarinatChangeHandler = (variant: any) => {
    if ((disableNonCreatedVariant && !variant.entry_variant_exist)) { } else if (!multiSelectTag) {
      onVariantClickHandler(variant)
    } else {
      let checkedIndex = variantTags.findIndex(item => item.value === variant.uid)
      let updatedTags: any = []
      if (checkedIndex !== -1) {
        updatedTags = [...variantTags]
        updatedTags.splice(checkedIndex, 1)
        setVariantTags(updatedTags)
      } else {
        updatedTags = [...variantTags, { label: variant.name, value: variant.uid }]
        setVariantTags(updatedTags)
      }
      onClickHandler && onClickHandler(updatedTags)
    }
  }
  return variantListData?.map((variantGroup, groupIndex: number) => {
    let isCTUnlinked = false;
    if (variantGroup && Array.isArray(variantGroup.content_types) && variantGroup.content_types.length) {
      let ctStatusObj = {} as any;
      variantGroup.content_types.forEach((ct) => {
        if (ct?.uid === selectedContentTypeName) {
          ctStatusObj = ct;
        }
      });
      if (ctStatusObj?.status == 'unlinked') {
        isCTUnlinked = true;
      }
    }
    const toolTipMsg = "Content-type unlinked"

    return (
      <div className="VariantList__group__wrapper" key={variantGroup.uid ? variantGroup.uid : groupIndex}>
        <div className="VariantList__group__label" tabIndex={-1} key={variantGroup.uid ? variantGroup.uid : groupIndex}>
          <div className='VariantList__group__label__name'>
            <Truncate
              isResponsive
              truncateFrom="end"
              testId={`cs-variant-${variantGroup.uid ? variantGroup.uid : '-group-name'}`}>
              {variantGroup.name}
            </Truncate>
          </div>
          {
            isCTUnlinked &&
            (
              <div className='unlinked-status' style={{ zIndex: 1 }}>
                <Tooltip
                  content={toolTipMsg}
                  position="top"
                  type="primary"
                >
                  <Icon icon='WarningBoldNew' size="medium" version='v2' />
                </Tooltip>
              </div>
            )
          }
        </div>
        <div className="VariantList__group__variants" key={groupIndex} data-test-id={`cs-variant-group-variants`}>
          {variantGroup?.variants?.map((variant, index) => {
            let isVariantUnlinked = false;
            if (variant?.personalize_metadata?.status === 'unlinked') {
              isVariantUnlinked = true;
            }
            let toolTipMsg = "Unlinked variant";
            let isVariantDisabled = (isCTUnlinked && !variant?.entry_variant_exist) ? true : false;
            const variantDom =
              variantListData.length === groupIndex + 1 &&
                (variantGroup?.variant_count === variantGroup?.variants.length
                  ? variantGroup.variant_count
                  : variantGroup?.variants.length) ===
                index + 1 ? (
                <div
                  tabIndex={isListDisabled ? -1 : 0}
                  {...(lastElementRef && { ref: lastElementRef })}
                  key={variant ? variant?.uid : index}
                  className={`VariantList__variant__label ${((disableNonCreatedVariant && !variant.entry_variant_exist) || isVariantDisabled) && 'VariantList__variant__label--disbaled'} ${clickableBaseclassname ? clickableBaseclassname : ''} flex`}
                  {...(onVariantClickHandler && { onClick: () => onVariantClickHandler(variant) })}>
                  <div className='VariantList__variant__label__name'>
                    {
                      multiSelectTag && (
                        <Checkbox
                          tabIndex={(disableNonCreatedVariant && !variant.entry_variant_exist) && -1}
                          checked={checkForSelectedVariant(variant.uid)}
                          onChange={() => { onVarinatChangeHandler(variant) }}
                        />
                      )
                    }
                    <Truncate
                      isResponsive
                      truncateFrom="end"
                      testId={`cs-variant-${variant.uid ? variant.uid : '-name'}`}>
                      {variant.name}
                    </Truncate>
                  </div>
                  <div className='VariantList__variant-list-items__icons'>
                    {
                      variant.entry_variant_exist &&
                      (<Icon icon='Variant' size="medium" version='v2' />)
                    }
                    {
                      (!isVariantDisabled && isVariantUnlinked) &&
                      (
                        <div className='unlinked-status' style={{ zIndex: 1 }}>
                          <Tooltip
                            content={toolTipMsg}
                            position="top"
                            type="primary"
                          >
                            <Icon icon='WarningBoldNew' size="medium" version='v2' />
                          </Tooltip>
                        </div>
                      )
                    }
                  </div>
                </div>
              ) : (
                <div
                  key={variant ? variant?.uid : index}
                  tabIndex={isListDisabled ? -1 : 0}
                  className={`VariantList__variant__label ${((disableNonCreatedVariant && !variant.entry_variant_exist) || isVariantDisabled) && 'VariantList__variant__label--disbaled'} ${clickableBaseclassname ? clickableBaseclassname : ''} flex-v-center`}
                  {...(onVariantClickHandler && { onClick: () => onVarinatChangeHandler(variant) })}>
                  <div className='VariantList__variant__label__name'>
                    {
                      multiSelectTag && (
                        <Checkbox
                          tabIndex={(disableNonCreatedVariant && !variant.entry_variant_exist) && -1}
                          className="flex-v-center"
                          checked={checkForSelectedVariant(variant.uid)}
                          onChange={() => { onVarinatChangeHandler(variant) }}
                        />
                      )
                    }
                    <Truncate
                      isResponsive
                      truncateFrom="end"
                      testId={`cs-variant-${variant.uid ? variant.uid : '-name'}`}>
                      {variant.name}
                    </Truncate>
                  </div>
                  <div className='VariantList__variant-list-items__icons'>
                    {
                      variant.entry_variant_exist &&
                      (<Icon icon='Variant' size="medium" version='v2' />)
                    }
                    {
                      (!isVariantDisabled && isVariantUnlinked) &&
                      (
                        <div className='unlinked-status' style={{ zIndex: 1 }}>
                          <Tooltip
                            content={toolTipMsg}
                            position="top"
                            type="primary"
                          >
                            <Icon icon='WarningBoldNew' size="medium" version='v2' />
                          </Tooltip>
                        </div>
                      )
                    }
                  </div>
                </div>
              )

            return variantDom
          })}
        </div>
      </div >
    )
  })
}
